module.exports = {
  purge: {
    content: [
      './app/**/*.php',
      './resources/**/*.{php,vue,js}',
    ],
  },
  darkMode: false, // or 'media' or 'class'
  theme: {
    extend: {
      colors: {},
      typography: {
        DEFAULT: {
          css: {
            color: '#636463',
            h1: {
              color: '#808180',
              fontSize: '2.25rem',
              fontWeight: '900',
              textTransform: 'uppercase',
            },
            h2: {
              color: '#808180',
              fontSize: '2.25rem',
              fontWeight: '900',
            },
            h3: {
              color: '#808180',
            },
            h4: {
              color: '#808180',
            },
            h5: {
              color: '#808180',
            },
            h6: {
              color: '#808180',
            },
            strong: {
              color: '#636463',
            },
          },
        },
      },
    },
    fontFamily: {
      'sans': ['Raleway', 'sans-serif'],
    },
    screens: {
      'sm': '640px',
      'md': '782px',
      'lg': '1024px',
      'xl': '1280px',
      '2xl': '1536px',
    },
  },
  variants: {
    extend: {},
  },
  plugins: [
    require('@tailwindcss/typography'),
  ],
};
